function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { Preguntas } from 'src/_candidato/data/Preguntas';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
var SeleccionPregsComponentCtrl = /*#__PURE__*/function () {
  SeleccionPregsComponentCtrl.$inject = ["$log", "NotifService", "AccesoDatos"];
  function SeleccionPregsComponentCtrl(
  //
  $log, NotifService, AccesoDatos) {
    _classCallCheck(this, SeleccionPregsComponentCtrl);
    _defineProperty(this, "filterq", '');
    _defineProperty(this, "verNoSeleccionables", false);
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(SeleccionPregsComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[SeleccionPregsComponentCtrl] onInit');
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.bloque) {
        this.$log.debug('Cambio bloque formulario', changes);
      }
    }
  }, {
    key: "addPreguntaFormulario",
    value: function addPreguntaFormulario(preg) {
      this.$log.debug('add pregn to formulario', preg);
      this.bloque.nuevaPregunta(preg);
    }
  }, {
    key: "refreshQ",
    value: function refreshQ() {
      var _this = this;
      this.AccesoDatos.EdicionFormular_CLIENT.listaPreguntas().then(function (response) {
        return _this.preguntas = new Preguntas(response);
      });
    }
  }]);
}();
angular.module('candidato').component('seleccionPregs', {
  bindings: {
    preguntas: '<',
    bloque: '<'
  },
  controller: SeleccionPregsComponentCtrl,
  template: require('./seleccion-pregs.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/seleccion-pregs/seleccion-pregs.component.html"
});